import { useState, useEffect } from 'react'
import axios from 'axios'
import { Select } from 'antd'

const FilterJobFairApplication = ({
    filterValue,
    setFilterValue,
    setCurrentPage
}) => {
    const [tempfilterValue, setTempFilterValue] = useState({})
    const [collegeFilter, setCollegeFilter] = useState([])
    const [companyTypeFilter, setCompanyTypeFilter] = useState([])

    useEffect(() => {
        callFilter()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const callFilter = () => {
        axios.post('/admin/job_fair/filter')
            .then(function (response) {
                if (response.errcode === 0) {
                    setCollegeFilter(response.data.colleges)
                    setCompanyTypeFilter(response.data.company_types)
                }
            })
            .catch(function (error) {
                console.error('请求失败，错误信息为：', error)
            })
    }

    let collegeItems = [
        {
            value: '',
            label: '全部'
        },
        ...collegeFilter.map((item) => (
            {
                value: item,
                label: item
            }
        ))
    ]

    let companyTypeItems = [
        {
            value: '',
            label: '全部'
        },
        ...companyTypeFilter.map((item) => (
            {
                value: item,
                label: item
            }
        ))
    ]

    let isTopCompanyItems = [
        {
            value: 0,
            label: '全部'
        },
        {
            value: 1,
            label: '是'
        },
        {
            value: 2,
            label: '否'
        }
    ]

    let auditStatusItems = [
        {
            value: 0,
            label: '全部'
        },
        {
            value: 1,
            label: '未审核'
        },
        {
            value: 2,
            label: '审核通过'
        },
        {
            value: 3,
            label: '审核未通过'
        }
    ]

    const clickCollegeFilter = (value) => {
        setTempFilterValue({ ...tempfilterValue, college: value })
    }

    const clickCompanyTypeFilter = (value) => {
        setTempFilterValue({ ...tempfilterValue, company_type: value })
    }

    const clickIsTopCompanyFilter = (value) => {
        setTempFilterValue({ ...tempfilterValue, is_top_company: value })
    }

    const clickAuditStatusFilter = (value) => {
        setTempFilterValue({ ...tempfilterValue, audit_status: value })
    }

    const clickSubmitFilter = () => {
        setFilterValue({ ...filterValue, ...tempfilterValue })
        setCurrentPage(1)
    }

    const clickResetFilter = () => {
        setFilterValue({ ...filterValue, college: '', company_type: '', is_top_company: 0, audit_status: 0 })
        callFilter()
        setTempFilterValue({})
    }

    return (
        <div className='public-conditions'>
            <div className='public-conditions-row'>
                <div className='public-condition'>
                    <div className='public-condition-label'>公司性质：</div>
                    <Select
                        value={tempfilterValue.company_type}
                        placeholder="请选择"
                        options={companyTypeItems}
                        style={{ width: '220px' }}
                        onChange={(value) => clickCompanyTypeFilter(value)}
                    />
                </div>

                <div className='public-condition'>
                    <div className='public-condition-label'>二级学院：</div>
                    <Select
                        value={tempfilterValue.industry}
                        placeholder="请选择"
                        options={collegeItems}
                        style={{ width: '220px' }}
                        onChange={(value) => clickCollegeFilter(value)}
                    />
                </div>

                <div className='public-condition'>
                    <div className='public-condition-label'>是否500强：</div>
                    <Select
                        value={tempfilterValue.is_top_company}
                        placeholder="请选择"
                        options={isTopCompanyItems}
                        style={{ width: '220px' }}
                        onChange={(value) => clickIsTopCompanyFilter(value)}
                    />
                </div>
            </div>

            <div className='public-conditions-row'>
                <div className='public-condition'>
                    <div className='public-condition-label'>审核状态：</div>
                    <Select
                        value={tempfilterValue.audit_status}
                        placeholder="请选择"
                        options={auditStatusItems}
                        style={{ width: '220px' }}
                        onChange={(value) => clickAuditStatusFilter(value)}
                    />
                </div>
            </div>

            <div className='public-conditions-buttons'>
                <div className='public-conditions-button1' onClick={() => { clickSubmitFilter() }}>筛选</div>
                <div className='public-conditions-button2' onClick={() => { clickResetFilter() }}>重置</div>
            </div>
        </div>
    )
}

export default FilterJobFairApplication
